module.exports = __webpack_public_path__ + "img/第5档.f0d5219d.png";